import { createContext, useContext } from 'react'

const TemplateContext = createContext(null)

export const useTemplateContext = () => useContext(TemplateContext)
export const TemplateContextProvider = TemplateContext.Provider
